import GA, { Tracker, GaOptions } from "react-ga";
import { isCordovaApp } from "utils/cordovaUtils";
import { Site } from "api/typedefs/Site";
import { onFirstPWAOpen } from "utils/pwa";
import { trackPwaInstall } from "./tracking";
import { generateGAStorageKey, getTrackerName } from "./utils";

const { REACT_APP_GA_ID } = process.env;
const GA_IDS = [REACT_APP_GA_ID];
let trackerCount = 0;
let hostname = "";
let GA_DOMAIN = "unconfigured.global.bible";

/********************************************************************************/
/*  Google Analytics can be reinitialized by passing in an array of additional  */
/*  GA Id numbers. There is no need to include the default GA Id, it will       */
/*  always be automatically included.                                           */
/********************************************************************************/

export async function initAnalytics(site: Site, host: string) {
  // set site specific variables
  const { subdomain, googleAnalyticsId: gaIds } = site;
  if (subdomain) GA_DOMAIN = `${subdomain}.global.bible`;
  if (gaIds) gaIds.split(",").forEach(gaId => GA_IDS.push(gaId));
  hostname = host;
  // initialize ga trackers
  try {
    await initTrackers();
  } catch (err) {
    console.error("There was an error while initializing anayltics client");
    return; // do no further initializing if trackers failed to be initialized
  }

  // analytics to capture on load
  try {
    onFirstPWAOpen(trackPwaInstall);
  } catch (err) {
    console.log(err);
  }
}

function initTrackers() {
  const isCordovaInit = isCordovaApp && window;
  const cordovaGaStorageKey = generateGAStorageKey();

  const trackers: Tracker[] = GA_IDS.map((gaId, index) => {
    // t + index matches google's schema, so
    const gaOptions: GaOptions = { name: getTrackerName(index) };
    if (isCordovaInit) {
      gaOptions.storage = "none";
      gaOptions.clientId =
        localStorage.getItem(cordovaGaStorageKey + index) || undefined;
    }
    return { trackingId: "" + gaId, gaOptions };
  });

  GA.initialize(trackers);

  if (isCordovaInit) {
    trackers.forEach((_, index) => {
      GA.ga((tracker: any) => {
        const key = cordovaGaStorageKey + index;
        window.localStorage.setItem(key, tracker.get(key));
      });
      GA.ga(`${index}.set`, "checkProtocolTask", () => {});
    });
  }

  trackerCount = trackers.length;
}

export const getTrackerCount = () => trackerCount;
export const getGaDomain = () => GA_DOMAIN;
export const getHostname = () => hostname;
